import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const LocationIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M18.0328 11.7116C17.5406 12.8771 16.8422 14.1648 16.0406 15.4666C14.7094 17.6378 13.1625 19.7386 12 21.2284C10.8375 19.7339 9.29063 17.6378 7.95938 15.4666C7.15781 14.1648 6.45937 12.8771 5.96719 11.7116C5.46094 10.5084 5.25 9.60611 5.25 9.02335C5.25 5.28712 8.27344 2.25584 12 2.25584C15.7266 2.25584 18.75 5.28712 18.75 9.02335C18.75 9.60611 18.5391 10.5084 18.0328 11.7116ZM13.1109 23.4607C15.5156 20.4435 21 13.1309 21 9.02335C21 4.04171 16.9688 0 12 0C7.03125 0 3 4.04171 3 9.02335C3 13.1309 8.48438 20.4435 10.8891 23.4607C11.4656 24.1798 12.5344 24.1798 13.1109 23.4607Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default LocationIcon
